import React, { useEffect, useState } from "react"
import { NumericFormat } from "react-number-format"
import { useTranslation } from "react-i18next"
import _get from "lodash/get"

import emailIcon from "@/public/icons/email.svg"
import phoneIcon from "@/public/icons/phone-icon.svg"
import {
  getShortenedUrlwithGeneral,
  getSiteWideModal,
  validateField,
  validatePhone,
} from "@/utils/helper"
import { convertToPhoneNumber } from "@/js/helperV2"
import ReCaptcha, {
  validateRecaptcha,
} from "@/components/core/ReCaptcha/ReCaptcha"

export const MadetoOrder = ({
  showModal,
  closeModal,
  activeTab,
  setActiveTab,
  config,
  ...props
}) => {
  const { t } = useTranslation()
  const staticTexts = {
    talktous: t("annsacks.annsacksPdp.talktous"),
    talktousatfreetime: t("annsacks.annsacksPdp.talktousatfreetime"),
    contactuslabel: t("kf.contactus.label.contactUsDisplayName"),
    chatwithus: t("annsacks.annsacksPdp.chatwithus"),
    chatwithusdescription: t("annsacks.annsacksPdp.chachatwithusdescription"),
    contactnumber: t("annsacks.annsacksPdp.contactnumber"),
    emaildescription: t("annsacks.annsacksPdp.emaildescription"),
    emailus: t("annsacks.annsacksPdp.emailus"),
    letuscontactyou: t("annsacks.annsacksPdp.letuscontactyou"),
    requiredFields: t("kf.checkout.label.requiredFields"),
    contactme: t("annsacks.annsacksPdp.contactme"),
    firstname: t("kf.contactus.label.firstName"),
    lastname: t("kf.contactus.label.lastName"),
    emailAddress: t("kf.contactus.label.emailAddress"),
    email: t("kf.reqAppointment.label.email"),
    phone: t("kf.checkout.label.phone"),
    preferenceTitle: t("annsacks.annsacksPdp.preferenceTitle"),
    privacyPolicy: t("kf.friendsandfamily.label.privacyPolicy"),
    subjectAccessRequest: t(
      "kf.associatemembership.label.subjectAccessRequest"
    ),
    termsOfService: t("kf.friendsandfamily.label.termsOfService"),
    firstnameError: t("kf.contactus.error.fnameError"),
    lastnameError: t("kf.contactus.error.lnameError"),
    validEmail: t("kf.contactus.error.validEmail"),
    noEmailError: t("kf.checkout.error.noEmailError"),
    noPhoneError: t("kf.contactus.error.noPhoneError"),
    validPhone: t("kf.checkout.error.validPhone"),
    sucessmsgTitle: t("annsacks.annsacksPdp.emailSent"),
    contactShortly: t("annsacks.annsacksPdp.contactShortly"),
    continueShopping: t("kf.compare.label.continueShopping"),
    goodtimetalk: t("annsacks.annsacksPdp.goodTimeTalk"),
    anyTime: t("annsacks.annsacksPdp.anyTime"),
    weekdays: t("annsacks.annsacksPdp.weekdays"),
    weekends: t("annsacks.annsacksPdp.weekends"),
    weekdaysMidDays: t("annsacks.annsacksPdp.weekdaysMidDays"),
    continue: t("kf.global.label.continue"),
    SFerrormessage: t("annsacks.annsacksPdp.SFerrormessage"),
  }
  const {
    legalPageData: {
      legalPageLinks
    },
    general = {},
  } = config
  const homePagePath = getShortenedUrlwithGeneral(
    general?.homepageUrl ?? "/",
    general
  )
  const [contactData, setContactData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    Preferred_Mode_of_Contact__c: staticTexts.email,
    Preferred_Day_Time_of_Contact__c: "",
  })
  const [preference, setPreference] = useState(staticTexts.email)
  const [talktime, setTalkTime] = useState(null)
  const [error, setError] = useState({})
  const [showSucessModal, setShowSucessModal] = useState(false)
  const [userErrormessage, setUserErrormessage] = useState(null)
  const { authorData } = props

  useEffect(() => {
    if (showModal) {
      setPreference(staticTexts.email)
      setUserErrormessage(null)
    }
  }, [showModal])

  const handleTabClick = tab => {
    setActiveTab(tab)
  }
  const onNameChange = e => {
    const { id, value } = e.target
    const field = id.split("-")
    if (value === "" || validateField("name", value)) {
      setContactData({
        ...contactData,
        [field[2]]: value,
      })
    }
    setError({
      ...error,
      [field]: validateExist(field),
    })
  }
  const onInputChange = e => {
    const { id, value } = e.target
    const field = id.split("-")
    setContactData({
      ...contactData,
      [field[2]]: value,
    })
  }
  const radioKeyDown = e => {
    const nextRadio = e.target.nextSibling
    const previousRadio = e.target.previousSibling
    if (e.key === "ArrowLeft" && previousRadio) {
      previousRadio.focus()
    } else if (e.key === "ArrowRight" && nextRadio) {
      nextRadio.focus()
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      e.target.click()
    }
  }

  const validateExist = field => {
    switch (field) {
      case "firstname":
      case "lastname":
        if (
          !contactData[field].trim() ||
          !validateField("name", contactData[field])
        ) {
          return field === "firstname"
            ? staticTexts.firstnameError
            : staticTexts.lastnameError
        }
        break
      case "email":
        if (!contactData[field]) return staticTexts.noEmailError
        else if (!validateField("email", contactData[field]))
          return staticTexts.validEmail
        break
      case "phone":
        if (!contactData.phone) return staticTexts.noPhoneError
        else if (!validatePhone(contactData.phone))
          return staticTexts.validPhone
        break
      default:
        return
    }
  }
  const onBlurError = field => {
    setError({
      ...error,
      [field]: validateExist(field),
    })
  }
  const getErrorList = () => {
    let errorList = {
      firstname: validateExist("firstname"),
      lastname: validateExist("lastname"),
      email: validateExist("email"),
      phone: validateExist("phone"),
    }
    return errorList
  }
  const onSubmit = () => {
    let errorDataList = []
    const errorList = getErrorList()
    setError(errorList)
    if (errorList.firstname) {
      errorDataList.push(`contact-user-firstname`)
    } else if (errorList.lastname) {
      errorDataList.push(`contact-user-lastname`)
    } else if (errorList.email) {
      errorDataList.push(`contact-user-email`)
    } else if (errorList.phone) {
      errorDataList.push(`contact-user-phone`)
    }
    errorDataList.forEach((item, i) => {
      if (i === 0) document.getElementById(`${item}`).focus()
    })

    let body = {
      Interaction_Type__c: "Interaction",
      Preferred_Email__c: contactData.email,
      PreferredPhone: contactData.phone,
      BP_Number__c: "3558798",
      LastName__c: contactData.lastname,
      Preferred_Day_Time_of_Contact__c:
        contactData.Preferred_Day_Time_of_Contact__c,
      FirstName__c: contactData.firstname,
      Preferred_Mode_of_Contact__c: contactData.Preferred_Mode_of_Contact__c,
    }
    validateRecaptcha().then(res => {
      if (res.success) {
        apim
          .post(`crm/quote`, body)
          .then(res => {
            if (res.data) {
              if (errorDataList.length === 0) {
                closeModal()
                setShowSucessModal(true)
                setContactData({
                  firstname: "",
                  lastname: "",
                  email: "",
                  phone: "",
                  Preferred_Mode_of_Contact__c: staticTexts.email,
                  Preferred_Day_Time_of_Contact__c: "",
                })
              }
            }
          })
          .catch(error => {
            console.error("Error in API call:", error)
            setUserErrormessage(
              authorData.errorCodeForSf ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: authorData.errorCodeForSf,
                  }}
                />
              ) : (
                <span>{staticTexts.SFerrormessage}</span>
              )
            )
          })
      }
    })
  }
  let checkDisabled = contactData => {
    if (
      contactData.firstname.trim() &&
      contactData.lastname.trim() &&
      contactData.email.trim() &&
      contactData.phone
    )
      return false
    return true
  }

  let contactInfo = authorData.contactusdetails

  const handleContactModeChange = value => {
    setPreference(value)
    setTalkTime(value === staticTexts.email ? "" : staticTexts.anyTime)
    setContactData({
      ...contactData,
      Preferred_Mode_of_Contact__c: value,
      Preferred_Day_Time_of_Contact__c:
        value === staticTexts.email ? "" : staticTexts.anyTime,
    })
  }

  const handleRadioClick = value => {
    if (preference === staticTexts.phone) {
      setTalkTime(value)
      setContactData({
        ...contactData,
        Preferred_Day_Time_of_Contact__c: value,
      })
    } else if (preference === staticTexts.email) {
      setContactData({
        ...contactData,
        Preferred_Day_Time_of_Contact__c: value,
      })
    }
  }

  const sucesscloseModal = () => {
    setShowSucessModal(false)
  }
  const footerClickHandler = (e, type, link) => {
    getSiteWideModal(e, link)
  }
  return (
    <>
      <Modal
        showModal={showModal}
        onModalClose={closeModal}
        className="made-to-order"
      >
        <div className="custom-order">
          <div className="custom-order-head">
            <h3 className="title">
              {authorData.talktous ? (
                <span
                  dangerouslySetInnerHTML={{ __html: authorData.talktous }}
                />
              ) : (
                <span>{staticTexts.talktous}</span>
              )}
            </h3>
            <p className="desc">
              {authorData.talktousatfreetime ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: authorData.talktousatfreetime,
                  }}
                />
              ) : (
                <span>{staticTexts.talktousatfreetime}</span>
              )}
            </p>
          </div>
          <div className="custom-order-body">
            <div className="custom-order-tab">
              <div className="order-tab-head">
                <ul>
                  <li
                    onClick={() => handleTabClick("contact")}
                    tabIndex="0"
                    role="button"
                    className={activeTab === "contact" ? "item active" : "item"}
                  >
                    {authorData.contactuslabel
                      ? authorData.contactuslabel
                      : staticTexts.contactuslabel}
                  </li>
                  <li
                    onClick={() => handleTabClick("connect")}
                    tabIndex="0"
                    role="button"
                    className={activeTab === "connect" ? "item active" : "item"}
                  >
                    {authorData.letuscontactyou
                      ? authorData.letuscontactyou
                      : staticTexts.letuscontactyou}
                  </li>
                </ul>
              </div>
              <div className="order-tab-content">
                {activeTab === "contact" && (
                  <div className="contact-info">
                    {contactInfo && contactInfo.length > 0 && (
                      <ul>
                        {contactInfo?.map((item, index) => {
                          return (
                            <li key={index}>
                              {/* <div className="icon">
                                <span>C</span>
                              </div> */}
                              <div className="info">
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    )}
                  </div>
                )}
                {activeTab === "connect" && (
                  <div className="connect-info contact-us-main">
                    <p className="error-info-text">
                      {staticTexts.requiredFields}
                    </p>
                    <form>
                      <div className="letus-form">
                        <div className="connect-row">
                          <div className="connect-col">
                            <Input
                              id="contact-user-firstname"
                              type="text"
                              value={contactData.firstname}
                              maxLength={40}
                              placeholder={`${staticTexts.firstname}*`}
                              label={`${staticTexts.firstname}*`}
                              onChange={onNameChange}
                              showError={error.firstname}
                              errorMessage={error.firstname}
                              onBlur={() => onBlurError("firstname")}
                            />
                          </div>
                          <div className="connect-col">
                            <Input
                              id="contact-user-lastname"
                              type="text"
                              value={contactData.lastname}
                              maxLength={40}
                              placeholder={`${staticTexts.lastname}*`}
                              label={`${staticTexts.lastname}*`}
                              onChange={onNameChange}
                              showError={error.lastname}
                              errorMessage={error.lastname}
                              onBlur={() => onBlurError("lastname")}
                            />
                          </div>
                        </div>
                        <div className="connect-row connect-email">
                          <Input
                            id="contact-user-email"
                            type="text"
                            value={contactData.email}
                            maxLength={60}
                            prefix={
                              <img src={emailIcon} alt="" aria-hidden="true" />
                            }
                            placeholder={`${staticTexts.emailAddress}*`}
                            label={`${staticTexts.emailAddress}*`}
                            onChange={onInputChange}
                            showError={error.email}
                            errorMessage={error.email}
                            onBlur={() => onBlurError("email")}
                          />
                        </div>
                        <div className="connect-row connect-phone">
                          <Input
                            id="contact-user-phone"
                            type="text"
                            value={contactData.phone}
                            maxLength={60}
                            prefix={
                              <img src={phoneIcon} alt="" aria-hidden="true" />
                            }
                            placeholder={`${staticTexts.phone}*`}
                            label={`${staticTexts.phone}*`}
                            onChange={e =>
                              setContactData({
                                ...contactData,
                                phone: convertToPhoneNumber(e.target.value),
                              })
                            }
                            showError={error.phone}
                            errorMessage={error.phone}
                            onBlur={() => onBlurError("phone")}
                          />
                        </div>
                      </div>
                      <div
                        className="preference"
                        role="radiogroup"
                        aria-labelledby="preferencetitle-radio"
                      >
                        <h3 className="title" id="preferencetitle-radio">
                          {staticTexts.preferenceTitle}
                        </h3>
                        <div className="pref-option">
                          <div className="option-col">
                            <RadioButton
                              id="email-preference"
                              name="contact-user-preference"
                              value={staticTexts.email}
                              checked={preference == staticTexts.email}
                              onClick={() =>
                                handleContactModeChange(staticTexts.email)
                              }
                              onKeyDown={radioKeyDown}
                            />
                          </div>
                          <div className="option-col">
                            <RadioButton
                              id="phone-preference"
                              name="contact-user-preference"
                              value={staticTexts.phone}
                              checked={preference === staticTexts.phone}
                              onClick={() =>
                                handleContactModeChange(staticTexts.phone)
                              }
                              onKeydown={radioKeyDown}
                              tabIndex={0}
                            />
                          </div>
                        </div>
                      </div>
                      {preference && (
                        <>
                          {preference === staticTexts.phone && (
                            <>
                              <div
                                className="preference phone-talk"
                                role="radiogroup"
                                aria-labelledby="phonetalk-radio"
                              >
                                <h3 className="title" id="phonetalk-radio">
                                  {staticTexts.goodtimetalk}
                                </h3>
                                <div className="pref-option">
                                  <div className="option-col">
                                    <RadioButton
                                      id="anyTime"
                                      name="timeOption"
                                      value={staticTexts.anyTime}
                                      checked={talktime === staticTexts.anyTime}
                                      onClick={() =>
                                        handleRadioClick(staticTexts.anyTime)
                                      }
                                      onKeydown={radioKeyDown}
                                    />
                                  </div>
                                  <div className="option-col">
                                    <RadioButton
                                      id="weekdays"
                                      name="timeOption"
                                      value={staticTexts.weekdays}
                                      checked={
                                        talktime === staticTexts.weekdays
                                      }
                                      onClick={() =>
                                        handleRadioClick(staticTexts.weekdays)
                                      }
                                      onKeydown={radioKeyDown}
                                      tabIndex={0}
                                    />
                                  </div>
                                  <div className="option-col">
                                    <RadioButton
                                      id="weekends"
                                      name="timeOption"
                                      value={staticTexts.weekends}
                                      checked={
                                        talktime === staticTexts.weekdaysMidDays
                                      }
                                      onClick={() =>
                                        handleRadioClick(
                                          staticTexts.weekdaysMidDays
                                        )
                                      }
                                      onKeydown={radioKeyDown}
                                      tabIndex={0}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                      <Button
                        role="button"
                        label={
                          authorData.contactme
                            ? authorData.contactme
                            : staticTexts.contactme
                        }
                        size="large"
                        type="primary"
                        flexible={true}
                        className="add-to-cart__main-button contact-me-btn"
                        id="submit-contact-form-button"
                        disabled={checkDisabled(contactData)}
                        onClick={() => onSubmit()}
                      />

                      <div className="recaptcha-info">
                        <ReCaptcha />
                      </div>
                      <div className="contact-us__policies">
                        <ul>
                          <li>
                            <a
                              href="#"
                              rel="noreferrer"
                              onClick={e =>
                                footerClickHandler(
                                  e,
                                  "privacy policy",
                                  legalPageLinks?.privacyPolicy
                                )
                              }
                            >
                              {staticTexts.privacyPolicy}
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              rel="noreferrer"
                              onClick={e =>
                                footerClickHandler(
                                  e,
                                  "subject access request",
                                  legalPageLinks?.subjectAccessRequest
                                )
                              }
                            >
                              {staticTexts.subjectAccessRequest}
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              rel="noreferrer"
                              onClick={e =>
                                footerClickHandler(
                                  e,
                                  "terms of service",
                                  legalPageLinks?.termsOfService
                                )
                              }
                            >
                              {staticTexts.termsOfService}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </form>
                    {userErrormessage && (
                      <p className="user-error"> {userErrormessage}</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="custom-order-product-info">
            <div className="order-product-img">
              <img src={props.productData.image} alt={props.productData.name} />
            </div>
            <div className="order-product-info">
              <div className="order-product-cnt">
                <h4 className="title">
                  {props.productSummaryDetails.productName_s}
                </h4>
                <p className="desc">
                  {props.ProductDescriptionDetail_s}, {props.productData.color}
                </p>
              </div>
              <div className="order-product-price-info">
                <span className="price-lable">
                  {props.staticTexts.startingAt}
                </span>
                <span className="price">
                  <NumberFormat
                    value={props.price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={props.currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                  <span className="range"> {props.priceTag}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* sucess */}
      <Modal
        showModal={showSucessModal}
        onModalClose={sucesscloseModal}
        className="made-to-order email-modal"
      >
        <div className="custom-order">
          <div className="custom-order-head">
            <h3 className="title">{staticTexts.sucessmsgTitle}</h3>
            <p className="desc">{staticTexts.contactShortly}</p>
          </div>
        </div>
        <div className="custom-order-body">
          <div className="email-btn-block">
            <Button
              role="button"
              label={staticTexts.continueShopping}
              size="large"
              type="primary"
              flexible={true}
              className="add-to-cart__main-button contact-email-btn"
              id="email-contact-form-button"
              to={homePagePath}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}
